import axios from "axios";
import { Endpoints } from "config/endpoints";
import { IFileItem } from "pages/Files/components/FileItem";

export type FileUrlType = "preview" | "original";
export interface IFileService {
  getServiceEndpoint(): string;
  setProperty(file:IFileItem ,property: string, value: string | number | boolean | string[]): any;
  updateFile(id: string, property: string, value:boolean| number| string | string[]): unknown;
  generateSharedLinks( ids: string[], expiresOn: Date ): Promise<string[] | undefined>;
  download(id: any, type: FileUrlType, regionPath: string): Promise<Blob | undefined>;
  getFiles(options: IFileQueryOptions, regionPath: string): Promise<any>;
  getFileURL( id: string,  type: FileUrlType | null, regionPath: string, token?: string | null): string;
  getStatusList(): any;
}

export interface IFileQueryOptions {
  options: {
    limit: number;
    skip: number;
  };
  filter?: any;
}

export const FileService: IFileService = {
  getServiceEndpoint: (): string => {
    return Endpoints.getEndpoint("REACT_APP_FILE_ENDPOINT");
  },

  getFiles: async (options: IFileQueryOptions, regionPath: string) => {
    const fileServiceUrl = FileService.getServiceEndpoint();
    const params = { ...options };
    const { data } = await axios.post(`${fileServiceUrl}file/query`, params, {
      headers: {
        "scope-data-isolation-idregion-path": regionPath,
      },
    });
    return data;
  },

  getFileURL: (
    id: string,
    type: FileUrlType,
    regionPath: string,
    token?: string | null
  ): string => {
    const fileServiceUrl = FileService.getServiceEndpoint();
    const urlType = type === "preview" ? `/preview/download` : "/download";
    const url = `${fileServiceUrl}file/${id}${urlType}`;
    if (token) {
      return `${url}?token=${token}&scope-data-isolation-idregion-path=${regionPath}`;
    }
    return url;
  },

  download: async (id: any, type: FileUrlType, regionPath: string): Promise<Blob | undefined> => {
    const url = FileService.getFileURL(id, type, regionPath);
    try {
      const { data } = await axios.get(url, {
        headers: { 
          "scope-data-isolation-idregion-path": regionPath,
        },
        responseType: "blob",
      });
      return data;
    } catch (error) {
      return undefined;
    }
  },

  generateSharedLinks: async (ids: string[], expiresOn: Date) => {
    try {
      const fileServiceUrl = FileService.getServiceEndpoint();
      const params = { expiresOn, files: ids };
      const url = `${fileServiceUrl}file/share`;
      const { data } = await axios.post(url, params, {
        headers: {
          "scope-data-isolation-enabled": "false",
        },
      });
      return data;
    } catch (error) {
      return undefined;
    }
  },
  updateFile: async (id: string, property: string, value: string | string[]) => {
    try {
      const fileServiceUrl = FileService.getServiceEndpoint();
      const params = { [property]: value };
      const url = `${fileServiceUrl}file/${id}`;
      const { data } = await axios.patch(url, params, {
        headers: {
          "scope-data-isolation-enabled": "false",
        },
      });
      return data;
    } catch (error) {
      return undefined;
    }
  },
  setProperty:  async (file : IFileItem, property: string, value:number | boolean | string | string[]) => {
    try {
      const fileServiceUrl = FileService.getServiceEndpoint();
      const params = { 
        [property]: value,
        idObject1 : file.idObject1,
       };
      const url = `${fileServiceUrl}file/${file.id}`;
      const { data } = await axios.put(url, params, {
        headers: {
          "scope-data-isolation-enabled": "false",
        },
      });
      return data;
    } catch (error) {
      return undefined;
    }
  },

  getStatusList: async () => {
    const fileServiceUrl = FileService.getServiceEndpoint();
    const { data } = await axios.get(`${fileServiceUrl}status/list`, {
      headers: {
        "scope-data-isolation-enabled": "false",
      },
    });
    return data;
  },
};
